import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, MapPin, Clock } from 'lucide-react';
import { siteInfo } from '../data/mock';
import { CartIcon } from './CartIcon';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Produits', path: '/produits' },
    { name: 'Galerie', path: '/galerie' },
    { name: 'Blog', path: '/blog' },
    { name: 'À Propos', path: '/a-propos' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Top bar */}
      <div className="bg-[#2C1810] text-[#E8DDD4] py-2 text-sm hidden md:block">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2">
              <Phone size={14} />
              {siteInfo.phone}
            </span>
            <span className="flex items-center gap-2">
              <MapPin size={14} />
              {siteInfo.address}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Clock size={14} />
            <span>Jeudi - Lundi: {siteInfo.hours.weekdays} | Mardi - Mercredi : Fermé </span>
          </div>
        </div>
      </div>

      {/* Main header */}
      <header className="bg-[#FDF8F3] sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#C9A96E] to-[#A67B5B] flex items-center justify-center">
                <span className="text-white font-bold text-xl font-serif">MB</span>
              </div>
              <div style={{ fontFamily: "'Playfair Display', serif" }}>
                <h1 className="text-2xl font-bold text-[#2C1810]">{siteInfo.name}</h1>
                <p className="text-xs text-[#A67B5B] tracking-wider uppercase">{siteInfo.tagline}</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`nav-link text-sm uppercase tracking-wide ${isActive(link.path) ? 'active' : ''}`}
                >
                  {link.name}
                </Link>
              ))}
            </nav>

            {/* Cart Icon & CTA Button */}
            <div className="hidden lg:flex items-center gap-4">
              <CartIcon />
              <Link
                to="/reservation"
                className="btn-primary px-6 py-3 rounded-full text-sm font-semibold uppercase tracking-wide inline-block"
              >
                Réserver
              </Link>
            </div>

            {/* Mobile Cart & Menu */}
            <div className="lg:hidden flex items-center gap-2">
              <CartIcon />
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="p-2 text-[#2C1810]"
                aria-label="Toggle menu"
              >
                {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="nav-mobile lg:hidden">
            <button
              onClick={() => setIsMenuOpen(false)}
              className="absolute top-6 right-6 p-2"
              aria-label="Close menu"
            >
              <X size={28} />
            </button>
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`text-2xl font-serif ${isActive(link.path) ? 'text-[#C9A96E]' : 'text-[#2C1810]'}`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/reservation"
              onClick={() => setIsMenuOpen(false)}
              className="btn-primary px-8 py-4 rounded-full text-lg font-semibold mt-4"
            >
              Réserver un RDV
            </Link>
          </div>
        )}
      </header>
    </>
  );
};
